import React, { useState } from "react";
import { BlackAndWhite } from "../../../../themes/Colors";

const HeadersTitle = ({ onClick, marginTop, viewOnly }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        minHeight: 50,
        display: "flex",
        borderTopColor: BlackAndWhite.primary,
        backgroundColor: BlackAndWhite.primary,
        color: BlackAndWhite.secondary,
        // borderTopLeftRadius: 8,
        // borderTopRightRadius: 8,
        marginTop: marginTop,
      }}
    >
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 15, width: "100%", textAlign: "left" }}>
          ROLE
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 0, width: "100%", textAlign: "left" }}>
          FIRST NAME
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 0, width: "100%", textAlign: "left" }}>
          SURNAME
        </div>
      </div>
      <div
        style={{
          flex: viewOnly ? 0.2 : 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div
          style={{
            marginLeft: 0,
            width: "100%",
            textAlign: viewOnly ? "center" : "left",
          }}
        >
          {viewOnly ? "STARTED ON" : "STORE"}
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 0, width: "100%", textAlign: "left" }}>
          PROVINCE
        </div>
      </div>
      <div
        style={{
          flex: 0.2,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div
          style={{
            marginLeft: 0,
            width: "100%",
            textAlign: "left",
          }}
        >
          EMAIL
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 0, width: "100%", textAlign: "left" }}>
          CELL
        </div>
      </div>
      <div
        style={{
          flex: 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        <div style={{ marginLeft: 0, width: "100%", textAlign: "left" }}>
          STATUS
        </div>
      </div>
      <div
        style={{
          flex: viewOnly ? 0 : 0.1,
          borderBottomStyle: "solid",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 11,
        }}
      >
        {viewOnly ? null : "ACTIONS"}
        {/* <div> Edit users</div>
        <div style={{ width: 20 }} /> */}
      </div>
    </div>
  );
};

export default HeadersTitle;
